/** A ready room's outline as the plan draws it — top of the plan up —, centred in a square, for the shape pickers. */
import { roomShapeOutline, type RoomShapeId } from '../state/roomShapes';

export function RoomShapePicture({ id, size = 40 }: { id: RoomShapeId; size?: number }) {
  const outline = roomShapeOutline(id);
  const xs = outline.map(p => p.x), zs = outline.map(p => p.z);
  const x0 = Math.min(...xs), z0 = Math.min(...zs), width = Math.max(...xs) - x0, depth = Math.max(...zs) - z0;
  const span = Math.max(width, depth) * 1.16, left = x0 + width / 2 - span / 2, top = z0 + depth / 2 - span / 2;
  return <svg className="room-shape-picture" width={size} height={size} viewBox={`${left} ${top} ${span} ${span}`} aria-hidden="true" focusable="false">
    <polygon points={outline.map(p => `${p.x},${p.z}`).join(' ')} fill="currentColor" fillOpacity={0.08} stroke="currentColor" strokeWidth={2}
      strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
  </svg>;
}
